import React from "react";
import clsx from "clsx";
import {Card} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {CardItem} from "./components";

const useStyles = makeStyles((theme) => ({
    listItem: {
        position: 'relative',
        background: theme.palette.paperColor,
        color: theme.palette.textColor,
        fontFamily: 'Arial',
        width: '100%',
        maxWidth: '100%',
        marginTop: 5,
        padding: '8px 0px',
        borderRadius: 2,
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'space-between',
        boxShadow: '0 0px 0px 0px rgba(248, 71, 62, 0.05)',
    },
}));

const ListGridItem = (props) => {
    const classes = useStyles();
    const { statesValue, radioList } = props;


    return(
        <Card
            className={clsx('list-item', classes.listItem)}
            raised={false}
        >
            {radioList && radioList.map((radio, ind) => {
                return (ind < 3 &&
                    <CardItem
                        key={ind}
                        image={radio.favicon}
                        title={radio.name}
                        subtitle={radio.tags}
                        url={radio.url_resolved}
                        radio_id={radio.stationuiid}
                    />
                );
            })}
        </Card>
    );
};

export default ListGridItem;
